import { useState } from 'react'
// import Drawer from '@/app/common/components/Drawer'
import { WizardFooter } from '@/app/pages/program_applications/vendor_application/components/WizardFooter.tsx'
import { WizardBodyContainer } from '@/app/pages/program_applications/vendor_application/components/WizardBodyContainer.tsx'
import { WizardStepTitle } from '@/app/pages/program_applications/vendor_application/components/WizardStepTitle.tsx'
import { WizardStepContent } from '@/app/pages/program_applications/vendor_application/components/WizardStepContent.tsx'
import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import Drawer from '@/common/components/Drawer.tsx'
import { useTranslation } from 'react-i18next'

const StepID = 0 as const
export default function LocationDeclaration() {
  const { t: translate } = useTranslation()
  const { setStepCompleted, goNext } = useWizardContext()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const validateForm = () => {
    setStepCompleted(StepID)
    goNext()
  }
  return (
    <>
      <WizardBodyContainer>
        <WizardStepTitle>{translate('location_declaration')}</WizardStepTitle>
        <WizardStepContent>
          <h3 className="font-semibold">
            {translate('are_you_a_provider_with_multiple_locations')}
          </h3>
          <p className="pl-8 text-gray-500">
            {translate('answer_yes_if_you_have_multiple_locations')}{' '}
            <span
              className="cursor-pointer pl-2 text-primary hover:underline"
              onClick={() => setDrawerOpen(true)}
            >
              {translate('learn_more')}
            </span>
          </p>

          <div className="pl-16 px-4 pt-4 pb-8">
            <div className="flex items-center gap-x-3 pb-2">
              <input
                id="yes"
                name="serviceLocations"
                type="radio"
                className="h-4 w-4 border-gray-600 text-primary-600 focus:ring-primary-600"
              />
              <label
                htmlFor="yes"
                className="block text-sm font-medium leading-6 text-gray-500"
              >
                <div className="text-black inline-block">
                  {' '}
                  {translate('yes')}
                </div>
                , {translate('multiple_service_locations')}
              </label>
            </div>
            <div className="flex items-center gap-x-3">
              <input
                id="no"
                name="serviceLocations"
                type="radio"
                className="h-4 w-4 border-gray-600 text-primary-600 focus:ring-primary-600"
              />
              <label
                htmlFor="no"
                className="block text-sm font-medium leading-6 text-gray-500"
              >
                <div className="inline-block text-black"> No</div>,{' '}
                {translate('single_service_location')}
              </label>
            </div>
          </div>
          <div className="h-px border-t pb-4"></div>
          <div className="flex flex-row px-2 py-4 my-auto">
            <div>
              <input
                id="comments"
                name="comments"
                type="checkbox"
                className="h-4 w-4 rounded border-gray-600 text-primary-600 focus:ring-primary-600"
              />
            </div>
            <div className="pl-4">
              <h3 className="font-semibold">
                {translate('service_location_agreement')}
              </h3>
              <p className="text-gray-500">
                {translate('understand_that_in_the_event')}
              </p>
              <p className="text-gray-500">
                {translate('will_register_each_location_separately')}
              </p>
            </div>
          </div>
        </WizardStepContent>
      </WizardBodyContainer>
      <WizardFooter onNext={validateForm} />
      <Drawer open={drawerOpen} setOpen={setDrawerOpen}>
        <h1 className="font-semibold text-gray-900 pt-12 pb-4">
          {translate('single_organization_providers')}
        </h1>
        <p>{translate('considered_a_single_organization_text')}</p>
        <h1 className="font-semibold text-gray-900 pt-12 pb-4">
          {' '}
          {translate('multi_organization_providers')}
        </h1>
        <p>{translate('considered_a_multi_organization_text')}</p>
      </Drawer>
    </>
  )
}
